<template>
  <div class="doctorpc-login">
    <div class="login-box">
      <div class="login-title">医生登录</div>
      <form-panel class="docpc-form" ref="loginForm" :arr="formArr" @change="formChange" @confirm="formConfirm"></form-panel>
      <div class="login-btn">
        <div class="btn-item">
          <van-button :color="themeColor" block :disabled="btnDisabled" @click="login()">登录</van-button>
        </div>
        <!-- <div class="btn-item">
          <van-button :color="themeColor" block :disabled="btnDisabled" @click="logout()">logout</van-button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import formPanel from "@/doctor_pc/components/form/form.vue"
import {
  doctorLogin,
} from '@/api/doctorapi'
import {
  Toast,
  Dialog,
} from "vant";
import {
  mapState,
  mapActions
} from "vuex";

export default {
  name: 'docpcApplyLogin',
  components: {
    formPanel
  },
  data() {
    return {
      themeColor: this.themeColor,
      btnDisabled: false,
      formArr: [
        {
          type: 'text',
          label: '用户名',
          name: 'name',
          value: '',
          require: 1,
        },
        {
          type: 'text',
          label: '身份证号',
          name: 'idsn',
          value: '',
          require: 1,
        },
        {
          type: 'text',
          limit: 'tel',
          label: '手机号码',
          name: 'mobile',
          maxlength: 11,
          value: '',
          require: 1,
          hasSmsCode: 1,
        },
        {
          type: 'text',
          limit: 'digit',
          label: '验证码',
          name: 'verifycode',
          maxlength: 6,
          value: '',
          require: 1,
        },
      ],
    }
  },
  computed: {
    ...mapState(['docpc']),
  },
  created() {
    console.log('docpcInfo', this.docpc)
  },
  methods: {
    ...mapActions(['SET_DOCPC_INFO','CLEAR_DOCPC_INFO','CLEAR_DOCPC_FORM']),
    formChange(e) {
      console.log('formChange',e)
    },
    formConfirm(value) {
      console.log('formConfirm',value)
      if (this.btnDisabled) {
        return
      }
      let req = {}
      for(let i in value) {
          let ele = value[i]
          req[ele.name] = ele.value
      }
      this.btnDisabled = true
      this.next(req)
    },
    login() {
      this.$refs.loginForm.next()
    },
    logout() {
      this.CLEAR_DOCPC_INFO()
    },
    next(req) {
      Toast.loading({forbidClick: true,duration:0});
      doctorLogin(req).then(res => {
        console.log('doctorLogin', res.data)
        this.CLEAR_DOCPC_FORM()
        if (res.data.doctor) {
          this.SET_DOCPC_INFO(res.data)
        }
        setTimeout(() => {
          this.$router.replace({
            name: "docpcBlank",
          });
          Toast.clear()
          this.btnDisabled = false
        }, 2000);
      }).catch(err => {
        Toast.clear()
          this.btnDisabled = false
          Toast(err.response.data.message)
      })
    }
  }
}
</script>
<style lang='less' scope>
html {
  background: #fff;
}
</style>
<style lang='less'>
.doctorpc-login {
  .login-box {
    width: 560px; margin: 80px auto;
    .login-title {
      font-size: 26px; text-align: center; margin-bottom: 30px;
    }
    .docpc-form {
      .van-cell--required {
        &::before {
          display: none;
        }
      }
      .van-field__label {
        margin-top: 9px; width: 4em;
      }
      .van-field__value {
        padding: 8px;
      }
    }
    .login-btn {
      .btn-item {
        width: 100px; margin: auto;
      }
    }
  }
}
</style>